module.exports = __webpack_public_path__ + "static/img/vip_privilege8.bc6a990.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/vip/vip_privilege8.png
// module id = aRlq
// module chunks = 0